/*
 * Copyright © 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output, TemplateRef} from '@angular/core';
import { MatRipple } from '@angular/material/core';
import {KEYCODES} from '../../core/constants';
import {NgTemplateOutlet} from '@angular/common';
import {MatIconButton} from '@angular/material/button';
import {MatTooltip} from '@angular/material/tooltip';
import {MatIcon} from '@angular/material/icon';

@Component({
    selector: 'elohn-item',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    providers: [MatRipple],
    imports: [MatRipple, NgTemplateOutlet, MatIconButton, MatTooltip, MatIcon]
})
export class ItemComponent {

    private readonly ripple = inject(MatRipple);

    @Input() nameTemplate?: TemplateRef<any>;
    @Input() iconTemplate?: TemplateRef<any>;
    @Input() canEdit = false;
    @Input() canDelete = true;
    @Input() canCheck = true;
    @Input() acronym?: string;
    @Input() displayName = '';
    @Input() mode = '';

    @Input() isActive = false;

    @Input() hasIconAnimation = true;

    @Output() readonly itemSelected = new EventEmitter<boolean>();
    @Output() readonly deleteItem = new EventEmitter<undefined>();
    @Output() readonly editItem = new EventEmitter<undefined>();

    public hasOperationControls = false;

    public onClick(event: MouseEvent): void {
        if (!event.defaultPrevented) {
            this.ripple.launch(event.x, event.y);
            this.setActive();
        }
    }

    public showOperations(): void {
        this.hasOperationControls = true;
    }

    public hideOperations(): void {
        this.hasOperationControls = false;
    }

    public onKeypress(event: KeyboardEvent): void {
        switch (event.key) {
            case KEYCODES.enter:
            case KEYCODES.space:
            case KEYCODES.spaceBar:
                this.ripple.launch({centered: true});
                this.setActive();
                break;
            default:
                break;
        }
    }

    public onEdit(event: Event): void {
        event.stopPropagation();

        this.editItem.emit(undefined);
    }

    public onDelete(event: Event): void {
        event.stopPropagation();

        this.deleteItem.emit(undefined);
    }

    private setActive(): void {
        this.hasOperationControls = false;

        this.itemSelected.emit(this.isActive);
    }
}
